<template>
  <div id="app" :class="`brand-theme-${config.cssBrand.toLowerCase()}`">
    <div class="container page">
      <router-view/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'App',
  computed: {
    config: function () {
      return this.$store.state.config
    },
    details: function () {
      return this.$store.state.details
    }
  },
  mounted () {
    // this.$router.push({name: 'WIA3'})
  }
}
</script>
<style lang="scss" scoped>
  @import './style/main.scss';
</style>
